<template>
  <v-container fluid>
    <HeaderPrint :rev="rev" />
    <div class="d-flex align-center">
      <p
        class="pa-0 my-3 subtitle-2 font-weight-bold blue-grey--text text--darken-3"
      >
        {{ $t('problem_solving.print.resume') }}
      </p>
    </div>
    <StatementPrint
      data-testid="reviewPrint_statement_problem_statement"
      :minHeight="100"
      :paragraph="problemStatement"
      :title="$t('problem_solving.define.problem_label')"
    />
    <StatementPrint
      data-testid="reviewPrint_statement_goals"
      :minHeight="100"
      :paragraph="goals"
      :title="$t('problem_solving.define.goal_label')"
    />
    <StatementPrint
      data-testid="reviewPrint_statement_finalSolution"
      :minHeight="100"
      :paragraph="finalSolution"
      :title="$t('problem_solving.solutions.final_solution')"
    />
    <div>
      <v-divider class="theme--print mt-1" />
      <ImpactsPrintView class="mt-3" plain :rev="rev" />
    </div>
  </v-container>
</template>

<script>
import HeaderPrint from './HeaderPrint.vue'
import StatementPrint from './StatementPrint.vue'
import ImpactsPrintView from '../../../components/Rev/Review/ImpactsPrintView.vue'

import userMixin from '@/mixins/userMixin'

export default {
  name: 'ReviewPrint',

  mixins: [userMixin],

  components: {
    HeaderPrint,
    StatementPrint,
    ImpactsPrintView,
  },

  props: {
    rev: {
      type: Object,
      required: true,
    },
  },

  computed: {
    title() {
      return this.$t('problem_solving.print.resume')
    },

    problemStatement() {
      return this.rev?.problemAnalysis?.problem ?? null
    },

    goals() {
      return this.rev?.problemAnalysis?.goals ?? null
    },

    finalSolution() {
      return this.rev?.solutionDescription ?? null
    },
  },
}
</script>
